import type { ReactNode } from 'react';

interface WizardSummaryPaneProps {
    children: ReactNode;
}

export function WizardSummaryPane({ children }: WizardSummaryPaneProps) {
    return (
        <div className="w-[300px] shrink-0 border-l border-gray-200 bg-gray-50 p-6 flex flex-col gap-4 overflow-y-auto">
            <span className="text-[12px] font-bold tracking-[0.005em] text-neutral-500 uppercase">
                Summary
            </span>
            {children}
        </div>
    );
}
